export default {
  calculate: 'Калькулятор',
  tasks: 'Задачи',
  task: 'Задачa',
  design: 'Дизайн',
  print: 'Печать',
  after_print: 'Послепечать',
  settings: 'Настройки',
  help: 'Помощь',
  logout: 'Выйти',
  autocoplete_placeholder: 'Начните вводить имя клиента',
  all: 'Все',
  my_tasks: 'Мои',
  paused_tasks: 'На паузе',
  tasks_archive: 'Архив',
  clients: 'Клиенты',
  shared_chat: 'Общий чат',
  activity_stream: 'Активности по задачам',
  yes: 'Да',
  no: 'Нет',
  warning: 'Внимание',
  do_you_want_leave: 'Вы уверены что хотите уйти с этой страницы?',
  accepted_by: 'Задача принята',
  refused_by: 'Задача отклонена',
  updated_by: 'Задача обновлена',
  finished_by: 'Задача завершена',
  paused_by: 'Задача поставлена на паузу',
  after_printer: 'Послепечатник',
  printer: 'Печатник',
  designer: 'Дизайнер',
  manager: 'Менеджер',
  director: 'Директор',
  master: 'Мастер',
  accountant: 'Бухгалтер',
  account_settings: 'Настройки аккаунта',
  send_message: 'Отправить сообщение...',
  ad_agent: 'Рекламный агент'
}
